import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { countriesDATA, planArea, logisticsData, bankData } from '../request';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor'; //富文本编辑区
import quillConfig from '@/views/components/editor/quill-config.js';
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import controlItem from '../controlItem.vue';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { statistics, control, controlGroup, fileFormat, controlGroupInfo } from '../utils';
import { uploadFile } from '../../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import addTableControlModel from '../addTableControlModel.vue';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import tableDesignModel from '../tableDesignModel.vue';
import relationModel from '../relationModel.vue';
import controlAction from './controlAction.vue';
import tableControl from './tableControl.vue';
import signModel from './signModel.vue'; //签名组件
import customModel from './customModel.vue'; //自定义组件

import SignatureControl from './SignatureControl.vue'; //签名组件--------------------
import ParagraphControl from './ParagraphControl.vue'; //段落组件----------
import fjModer from './fjModer.vue'; //段落组件----------

const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB
import { mapState, mapMutations } from 'vuex';
export default {
  props: {
    groupItem: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: null
    },
    groupFormData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    topTitle,
    areaSelect,
    previewModal,
    controlItem,
    addTableControlModel,
    tableDesignModel,
    relationModel,
    quillEditor,
    signModel,
    tableControl,
    customModel,
    controlAction,
    SignatureControl,
    //签名组件
    ParagraphControl,
    fjModer
  },
  data() {
    return {
      optionsData: {
        optionsAA: [{
          value: 2,
          label: this.$t('每行2列')
        }, {
          value: 3,
          label: '每行3列'
        }, {
          value: 4,
          label: '每行4列'
        }, {
          value: 5,
          label: '每行5列'
        }, {
          value: 6,
          label: '每行6列'
        }, {
          value: 7,
          label: '每行7列'
        }, {
          value: 8,
          label: '每行8列'
        }, {
          value: 9,
          label: '每行9列'
        }, {
          value: 10,
          label: '每行10列'
        }],
        value: 2
      },
      // 下拉国家数据
      currentOptions: [],
      //获取接口数据
      propsTree: {
        children: 'children',
        label: 'name',
        value: 'id',
        multiple: false
      },
      selectedValue: '',
      //单选选中数据国家
      getcountData: [],
      areaList: [],
      valuedata: [],
      //存储省市数据
      provinceDATA: [],
      //获取接口数据
      // 签名控件
      signatureIMAGE: '',
      //签名默认为空
      // 段落控件
      controlCount: 0,
      // 控件序号
      quillOption: quillConfig,
      // 定义一个全局的index作为传值 附件
      // 单选 横向 竖向
      // sortWay: 'TRANSVERSE', //默认横向展示
      // columnsPerRow: 3,
      // 结束
      selectedOption: '',
      //被选中的选项值
      showInput: false,
      //默认隐藏
      inputValue: '',
      //输入框
      formeFalse1: false,
      // 附件内容
      activeIndex: null,
      Datatemplate: [],
      //上传的文件数据
      fileListData: [],
      //上传的文件数据
      DatatemplateFalse: false,
      indexQJ: null,
      //定义文件长传的index用于传值
      isModalVisible: false,
      //文件数据
      // 日期控件
      dateTimeValue: 'date',
      selectedDate: null,
      selectedDateTime: null,
      dateFormat: 'YYYY-MM-DD',
      dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
      startTimeOption: 'unlimited',
      specificTime: null,
      relativeTime: 0,
      relativeUnit: 'days',
      visiblecustom: false,
      //下拉选择自定义
      selectedcustom: false,
      //下拉选择自定义
      // formDataArray: [], //获取的数据 用于v-for循环数据列表
      MinMaxindex: 0,
      //每个点击项的索引值作为全局使用
      DataArray: [],
      titleInput: '',
      //表单区名称
      isSelected: false,
      //关联、下拉、编辑
      // 存储的表单数据
      formData: {},
      minWordCount: 0,
      maxWordCount: 500,
      rulesTrue: {
        //统一控件说明如下：
        // 名称设置：
        // 控件名称：单行文本框，限制为0-500个字符。
        // 默认情况下，将填入控件类型的名称。
        // 非必填。如果删除了控件名称，在控件位置上方会进行补位。如果控件名称过长，会根据页面宽度换行显示。
        controlName: [{
          required: false,
          message: this.$t('请输入') + this.$t('控件名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: this.$t('长度在 1 到 500 个字符之间'),
          trigger: 'blur'
        }],
        promptText: [{
          message: this.$t('长度最多为 100 个字符'),
          trigger: 'blur'
        }],
        controlExplain: [{
          max: 100,
          message: this.$t('长度最多为 100 个字符'),
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入标识'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('长度在 1 到 50 个字符之间'),
          trigger: 'blur'
        }],
        prefix: [{
          message: this.$t('请输入...'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度在 1 到 50个字符'),
          trigger: 'blur'
        }],
        suffix: [{
          message: this.$t('请输入....'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度在 1 到 100个字符'),
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入....'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: this.$t('长度在 1 到 100个字符'),
          trigger: 'blur'
        }],
        phoneRules: [{
          required: true,
          message: this.$t('请输入手机号'),
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: this.$t('手机号格式不正确'),
          trigger: 'blur'
        }],
        idCardRules: [{
          required: true,
          message: this.$t('请输入身份证号')
        }, {
          pattern: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
          message: this.$t('身份证号格式不正确')
        }],
        emailRules: [{
          required: false,
          message: this.$t('请输入邮箱'),
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]{1,18}@[a-zA-Z0-9]+\.com$/,
          message: this.$t('邮箱格式不正确'),
          trigger: 'blur'
        }],
        // 文件格式验证
        fileFormat: [{
          type: 'array',
          required: true,
          message: this.$t('请选择') + this.$t('文件格式'),
          trigger: 'change'
        }],
        // // 文件大小
        fileSize: [{
          type: 'number',
          required: true,
          message: this.$t('请选择') + this.$t('文件大小'),
          trigger: 'blur'
        }],
        // //日期
        // dateType: [{required: true, message: this.$t('请选择') + this.$t('日期类型'), trigger: 'change'}]
        // 选项值文本
        name: [{
          required: true,
          message: this.$t('选项值不能为空'),
          trigger: 'blur'
        }]
      },
      defaultOption: '全部',
      subDataList: [],
      // 结束--------------------------------------------------------
      //图片需要参数
      action: uploadFile,
      uploadAccept: '',
      checkAll: false,
      indeterminate: false,
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      statistics,
      control,
      controlGroup,
      dialogVisible: false,
      isEdit: false,
      dataForm: {
        partsType: '',
        formName: '',
        controlName: '',
        controlExplain: '',
        promptText: '',
        other: '',
        type: '',
        optionList: [],
        fileFormat: [],
        template: []
      },
      dataGroupForm: {},
      dataGroupRules: {},
      name: '',
      checked: false,
      //默认必填为否
      controlList: [],
      containerVisible: false,
      tableDesignModelVisible: false,
      relationModelVisible: false,
      relationData: [],
      relationModelIndex: 0,
      tableId: '',
      tableMark: '',
      // 关联模块相关
      isHaveRelation: false
    };
  },
  computed: {
    controlInfo() {
      return {
        1: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }]
        },
        2: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          option: [{
            required: true,
            message: this.$t('请填写控件选项，不同选项用“，”隔开'),
            trigger: 'blur'
          }]
        },
        3: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: this.$t('请选择') + this.$t('类别'),
            trigger: 'change'
          }]
        },
        4: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          dateType: [{
            required: true,
            message: this.$t('请选择') + this.$t('日期类型'),
            trigger: 'change'
          }]
        },
        5: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          fileFormat: [{
            type: 'array',
            required: false,
            message: this.$t('请选择') + this.$t('文件格式'),
            trigger: 'change'
          }]
        },
        6: {
          operation: [{
            required: true,
            message: this.$t('请选择') + this.$t('操作'),
            trigger: 'change'
          }]
        },
        7: {}
      };
    },
    item() {
      return this.groupItem;
    },
    groupDatas() {
      return this.groupFormData;
    },
    ...mapState('control', ['controlDatas', 'activeIdx', 'groupItemActiveIdx', 'groupSelected']),
    formDataArray: {
      get() {
        return this.controlDatas;
      },
      set(val) {
        this.$emit('formDataArray', val);
      }
    }
  },
  watch: {
    selectedValue(newValue) {
      console.log('选中的值为:', newValue);
    },
    minWordCount(newMin, oldMin) {
      if (this.maxWordCount <= newMin) {
        this.maxWordCount = newMin + 1;
      }
    },
    activeIdx(val) {
      if (val) {
        this.groupDatas.forEach((item, index) => {
          item.isCheck = false;
        });
      }
    }
  },
  created() {},
  mounted() {
    console.log('获取  id-------', this.itemid);
    // this.getcount();
    // this.$nextTick(() => {
    //   this.initCanvas();
    // });
  },
  methods: {
    // 禁止输入负数
    parseNonNegativeNumber(value) {
      const parsedValue = parseFloat(value);
      if (isNaN(parsedValue) || parsedValue < 0) {
        return 0; // 设置为默认值或其他非负数
      }
      return parsedValue;
    },
    ...mapMutations({
      SET_ACTIVE_IDX: 'control/SET_ACTIVE_IDX',
      SET_GROUP_ITEM_ACTIVE_IDX: 'control/SET_GROUP_ITEM_ACTIVE_IDX',
      SET_CONTROL_DATAS: 'control/SET_CONTROL_DATAS'
    }),
    // 日期事件
    timeSelectChange(item) {
      if (item.type === 'SPECIFIC_TIME' && item.dateInput) {
        item.dateInput = '';
      } else {
        item.value = '';
      }
    },
    // 点击显示  下拉、上移、编辑按钮
    toggleSelection(index) {
      // console.log(this.activeIdx,index,this.formDataArray,this.formDataArray[this.activeIdx],'------点击获取当前父级idx-----',this.item)
      // 判断父级是否选中状态
      if (this.groupSelected && this.item.groupSelected) {
        this.item.isCheck = true;
        this.item.groupSelected = true;
        // console.log(this.formDataArray, '-----子集选中-----', this.groupItemActiveIdx);
        this.SET_GROUP_ITEM_ACTIVE_IDX(index);
        this.changeFormDataArray(index, false);
      }
    },
    // 修改数据的isCheck
    changeFormDataArray(idx) {
      // console.log(idx, '----groupItem-----');
      this.groupDatas.forEach((item, index) => {
        if (idx === index) {
          item.isCheck = true;
          // item.groupSelected = true
        } else {
          item.isCheck = false;
        }
      });
      this.SET_CONTROL_DATAS(this.formDataArray);
      this.$forceUpdate();
    },
    // top点击事件显示输入框
    handleOptionClick(item1, index2) {
      this.formDataArray[index2].selectedOption = item1.name;
      this.formDataArray[index2].controlValue.forEach(item => {
        if (item !== item1) {
          item.showInput = false;
          item.emptyValue = '';
        }
      });
      item1.showInput = item1.isWrite;
      item1.emptyValue = '';
    },
    // 多选控件事件 数值控制 最大值 最小值
    handleNumberLimit1Change(index) {
      if (this.item.numberLimit1 >= this.item.numberLimit2) {
        // 如果第一个输入框的值大于等于第二个输入框的值，则将第二个输入框的最小值设置为第一个输入框的值加1
        this.item.numberLimit2 = this.item.numberLimit1 + 1;
      }
    },
    handleOptionChange(item2, index2) {
      if (item2.isWrite) {
        const index = this.formDataArray[index2].selectedOptionsDX.indexOf(item2.name);
        if (index !== -1) {
          this.formDataArray[index2].controlValue.forEach(opt => {
            if (opt.name === item2.name) {
              opt.emptyValue = '';
            }
          });
        } else {
          this.formDataArray[index2].controlValue.forEach(opt => {
            if (opt.name === item2.name) {
              opt.emptyValue = null;
            }
          });
        }
      }
    },
    // 多选添加
    addOptionDX(index, index2) {
      const newOption = {
        name: '',
        isWrite: false,
        emptyValue: '',
        association: {
          type: '',
          // "or或 and且",
          association: [] // 如果为空则代表没有关联关系
        }
      };
      // 添加判断不能为空 为空提示  不能添加新的文本
      const hasEmptyValue = this.item.controlValue.some(option => option.name === '');
      // 选项值重复处理
      const hasDuplicate = this.item.controlValue.findIndex((option, i) => option.name === newOption.name && i !== index) !== -1;
      if (hasEmptyValue) {
        this.$message.error(this.$t('选项值不能为空'));
      } else if (hasDuplicate) {
        this.$message.error(this.$t('选项值重复'));
      } else {
        this.item.controlValue.push(newOption);
        // this.options.splice(index + 1, 0, newOption);
      }
      // this.formDataArray[index2].controlValue.push(newOption);
      // this.formDataArray[index2].controlValue.splice(index + 1, 0, newOption);
    },
    //上移多选
    moveUpDX(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index - 1, 0, option);
    },
    //下移多选
    moveDownDX(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index + 1, 0, option);
    },
    deleteOptionDX(index, index1) {
      this.groupDatas[index1].controlValue.splice(index, 1);
    },
    // 单选控件事件
    addOptionDA(index, index1) {
      console.log('单选事件点击增加--', index);
      const newOption = {
        name: '',
        isWrite: false,
        emptyValue: '',
        association: {
          type: '',
          // "or或 and且",
          association: [] // 如果为空则代表没有关联关系
        }
      };
      // this.item.controlValue.push(newOption);

      // 添加判断不能为空 为空提示  不能添加新的文本
      const hasEmptyValue = this.item.controlValue.some(option => option.name === '');
      // 选项值重复处理
      const hasDuplicate = this.item.controlValue.findIndex((option, i) => option.name === newOption.name && i !== index) !== -1;
      if (hasEmptyValue) {
        this.$message.error(this.$t('选项值不能为空'));
      } else if (hasDuplicate) {
        this.$message.error(this.$t('选项值重复'));
      } else {
        this.item.controlValue.push(newOption);
        // this.options.splice(index + 1, 0, newOption);
      }
      // this.formDataArray[index1].controlValue.splice(index + 1, 0, newOption);
      // 是一个数组操作的语句，它使用splice方法在this.formDataArray[index1].controlValue数组中的指定位置插入一个新元素newOption。
    },
    // 上移单选
    moveUpDA(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index - 1, 0, option);
    },
    // 下移单选
    moveDownDA(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index + 1, 0, option);
    },
    deleteOptionDA(index, index1) {
      this.groupDatas[index1].controlValue.splice(index, 1);
    },
    // 单选结束
    // 下拉控件事件开始------------------------------------------------------
    // 是否多选事件
    MultipleShow(item, index) {
      if (item.isMultipleChoice === false) {
        // 清空单选情况下的选择值
        this.formDataArray[index].selectedValues = [];
        this.propsTree.multiple = false;
        console.log('点击否', this.selectedValue);
      } else if (item.isMultipleChoice === true) {
        // this.selectedValues = ''; // 清空单选情况下的选择值
        this.formDataArray[index].selectedValues = [];
        this.propsTree.multiple = true;
        console.log('点击是', this.selectedValue);
      }
    },
    //下拉国家 省市 省市区
    customClickVue(item, index) {
      // 自定义
      if (item === 'custom') {
        this.visiblecustom = true;
        this.treelist(index);
        // this.$nextTick(() => {
        //   this.visiblecustom = true; // 在下一个渲染周期中设置为true
        // });
      }
      // 职业
      if (item === 'profession') {
        this.currentOptions = [];
      }
      // 国家
      if (item === 'country') {
        this.getcount(index);
      }

      // 省
      if (item === 'provinceFirstLevel') {
        this.getprovince(index);
      }
      // 省市
      if (item === 'province') {
        this.getprovinceS(index);
      }
      // 省市区
      if (item === 'provinceArea') {
        this.getprovinceArea(index);
      }
      // 开户行
      if (item === 'bank') {
        this.getbank(index);
      }
      // 物流
      if (item === 'logistics') {
        this.getlogistics(index);
      }
    },
    // 下拉自定义事件
    handleOk(index) {
      this.visiblecustom = false;
      // this.formDataArray[index].type.type = '';
    },
    // 获取创建的tree数据  ---2、自定义列表数据
    treelist(data, index) {
      // 处理从子组件传递过来的树形数据
      this.item.Customvalues = data;
      // console.log('子传父--2、自定义列表数据', data);
    },
    // 更新选中的值'
    handleCascaderChange(value) {
      // this.item.selectedValues = value; // 更新选中的值
      // console.log('更新选中的值', this.item.selectedValues);
    },
    // 获取省数据
    async getprovince() {
      const res = await planArea({
        level: 1,
        type: 'noAll'
      });
      this.item.Customvalues = res;
    },
    // 获取省市数据
    async getprovinceS(index) {
      // this.provinceDATA = await planArea({level: 2});
      const res = await planArea({
        level: 2,
        type: 'noAll'
      });
      this.item.Customvalues = res;
    },
    // 获取省市区数据
    async getprovinceArea(index) {
      // this.provinceDATA = await planArea({level: 2});
      const res = await planArea({
        level: 3,
        type: 'noAll'
      });
      this.item.Customvalues = res;
    },
    // 获取开户行
    async getbank(index) {
      const res = await bankData({
        level: 1
      });
      this.item.Customvalues = res;
    },
    // 获取物流
    async getlogistics(index) {
      const res = await logisticsData({
        level: 1
      });
      this.item.Customvalues = res;
    },
    // 取出 item中的值进行分割取值，取最大值、取最小值
    getMinValue(numberLimit) {
      const [minValue] = numberLimit.split(',');
      return parseInt(minValue);
    },
    getMaxValue(numberLimit) {
      const [, maxValue] = numberLimit.split(',');
      return parseInt(maxValue);
    },
    // 1、单行文本业务逻辑-----------------------开始----------------------------------------
    minMaxNav(index) {
      this.MinMaxindex = index;
      console.log('获取每个节点的index', index);
    },
    // 单行文本 小数点位数 没有输入内容 并且失去焦点 将数据设置为默认状态

    // 附件控件逻辑-----------------------------开始-------------------------------
    clickfu(index) {
      if (!this.formDataArray[index].fileNumber.value) {
        this.formDataArray[index].fileNumber.value = 10;
      }
    },
    // 当输入框被清空时，parseInt() 函数会返回 NaN（Not a Number），
    handleInputBlur(fileNumber) {
      if (!fileNumber.value || isNaN(fileNumber.value)) {
        fileNumber.value = 2; // 设置默认值为 2 或其他合适的值
      }
    },
    fileSizeBlur(fileSize) {
      if (!fileSize.size || isNaN(fileSize.size)) {
        fileSize.size = 1; // 设置默认值为 2 或其他合适的值
      }
    },
    formatInteger(value) {
      return value ? String(parseInt(value)) : '';
    },
    // 单行文本 小数点位数 没有输入内容 并且失去焦点 将数据设置为默认状态
    //   先检查 decimalPlaces 是否为空（falsy 值），并且不等于 0。如果满足这两个条件，则将 decimalPlaces 设置为默认值 2。
    // 通过这个修改，当清空输入框并失去焦点时，会将其值设置为默认值 2，以确保始终存在一个非空的值。
    xsdDefault1(index) {
      if (!this.item.decimalPlaces) {
        this.item.decimalPlaces = 2;
      }
    },
    // 单行文本 没有输入内容 并且失去焦点 将数据设置为默认状态
    zsxzDefault1(index) {
      if (!this.item.textMinLength) {
        this.item.textMinLength = 0;
      }
    },
    zsxzDefault1(index) {
      if (!this.item.textMinLength) {
        this.item.textMinLength = 0;
      }
    },
    zsxzDefault2(index) {
      if (!this.item.textMaxLength) {
        this.item.textMaxLength = 200;
      }
    },
    //数值限制 最大  默认值

    szxzNumberMAX(index) {
      if (!this.item.numberMaxValue) {
        this.item.numberMaxValue = 40000000;
      }
    },
    updateNumberMaxValue() {
      const decimalPlaces = this.formData.decimalPlaces;
      const minValue = this.formData.numberMinValue;
      this.formData.numberMaxValue = Math.pow(10, decimalPlaces) * 40000000 + minValue;
    },
    //
    // 多行文本业务逻辑
    // 多行文本--字数限制
    multilineMIN(index) {
      if (!this.item.minWordCount) {
        this.item.minWordCount = 0;
      }
    },
    // 多行文本--字数限制
    multilineMAX(index) {
      if (!this.item.maxWordCount) {
        this.item.maxWordCount = 500;
      }
    },
    // 编辑按钮--打开内容输入内容
    formeClick(index, type) {
      // console.log('编辑点击事件', item, index);
      if (type === 'table') {
        //表格控件的编辑特殊处理
        this.tableId = this.item.containerTemplateId;
        if (this.tableId !== -1) {
          let obj = {
            type: 'table',
            tableType: 'increment',
            tableUsage: 'control',
            id: this.tableId,
            mark: this.item.mark
          };
          sessionStorage.setItem('tableInitInfo', JSON.stringify(obj));
          this.tableDesignModelVisible = true;
        } else {
          this.tableMark = this.item.mark;
          this.containerVisible = true;
        }
      } else {
        this.item.editing = !this.item.editing;
      }
    },
    // 关闭事件
    formClose(index) {
      this.item.editing = false;
    },
    // 关联控件
    relationClick(index) {
      this.relationModelVisible = true;
      this.relationModelIndex = index;
      let relationArr = [];
      this.formDataArray.forEach((item, index1) => {
        if (['singleChoice', 'multipleChoice', 'dropDown'].indexOf(item.partsType) != -1 && index1 < index) {
          relationArr.push(item);
        }
      });
      this.relationData = relationArr;
    },
    editSubData(subData) {
      // 编辑逻辑
    },
    // 模板预览打开
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    // 预览文件
    async handlePreview(file, fileList) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      if (isExcel(file.name)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式打不开
      if (isWord(file.name)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(file.name);
      this.isxlsxShow = isExcel(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.formDataArray[this.index].templateUrl.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else if (this.isxlsxShow) {
        this.previewXLSX = file.url || file.response.data.fileTempUrl;
        window.open(this.previewXLSX);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    // 单选
    onChangeFormat(index) {
      console.log('点击事件--获取文件类型数据', this.item.fileFormat);
      this.toChangeUploadAccept(this.item.fileFormat);
    },
    // 文件上传逻辑
    clickPlusTWO(index) {
      // this.indexQJ = index;
      // console.log('获取点击的index', index);
      // // 文件的类型的数据
      // if (this.item.fileFormat.length == 0) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      // 定义一个全局的index
      // const index = this.indexQJ;
      // const isVideoFile = isVideo(file.name);
      // const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      // if (!this.isFileSizeValid(file, maxSize)) {
      //   const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
      //   this.$message.error(errorMessage);
      //   return;
      // }

      // const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      // // 文件类型
      // if (!this.item.fileFormat.includes(fileType)) {
      //   this.$message.error(this.$t('文件格式错误'));
      //   return;
      // }
      // 文件列表
      this.item.fileListData = fileList.map(item => {
        if (item.response && item.response.code === 200 && item.status === 'done') {
          item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
          // 将文件URL添加到templateUrl变量中
          this.item.templateUrl += item.url + ',';
        }
        // return item; //获取文件全部属性数据
        return {
          uid: item.uid,
          name: item.name,
          url: item.url,
          status: item.status,
          // thumbUrl: item.thumbUrl,
          response: item.response
        };
      });
      // 移除最后一个逗号
      this.item.templateUrl = this.item.templateUrl.slice(0, -1);
      this.showActionButtons = true;
    },
    // 附件上传新建
    beforeUpload(file) {
      // const index = this.indexQJ;
      // console.log('获取点击的index -------beforeUpload', index);
      // // if (this.item.fileFormat.length == 0) {
      // if (this.item.fileFormat.length < 0) {
      //   this.$message.error('请选择1111文件格式');
      //   return;
      // }
      // const extension = file.name
      //   .split('.')
      //   .pop()
      //   .toLowerCase();
      // // "fileFormat": "文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg
      // const isValidType = this.item.fileFormat.includes(extension);
      // if (!isValidType) {
      //   this.$message.error(this.$t('无效的文件格式'));
      // }
      // const isValidSize = file.size / (this.item.fileSize.type === 'MB' ? 1024 * 1024 : 1024) < this.item.fileSize.size;
      // if (!isValidSize) {
      //   this.$message.error(this.$t('文件大小超过限制'));
      // }
      // return isValidType && isValidSize;
    },
    // 结束
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      // console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    isFileSizeValid(file, maxSize) {
      return file.size / 1024 / 1024 < maxSize;
    },
    changeUpload({
      file,
      fileList
    }) {
      // console.log('获取验证规则', file, fileList);
      const isThanMax = file.size / 1024 / 1024 < 50;
      const isVideoThanMax = file.size / 1024 / 1024 < 300;
      if (isVideo(file.name)) {
        if (!isVideoThanMax) {
          this.$message.error(this.$t('文件最大不超300M'));
          return;
        }
      } else {
        if (!isThanMax) {
          this.$message.error(this.$t('文件最大不超50M'));
          return;
        }
      }
      // this.item.fileFormat
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      const res = this.DataArray.indexOf(fileType);
      if (res > -1) {
        this.Datatemplate = fileList.map(item => {
          if (item.response && item.response.code == 200 && item.status == 'done') {
            if (process.env.NODE_ENV === 'production') {
              item.url = cryptoDecrypt(item.response.data).fileTempUrl;
            } else {
              item.url = item.response.data.fileTempUrl;
            }
          }
          return item;
        });
        console.log('-------', this.Datatemplate);
      } else {
        this.$message.error(this.$t('文件格式错误'));
      }
      setTimeout(() => {
        const classActions = document.getElementsByClassName('ant-upload-list-item-actions');
        if (classActions.length > 0) {
          for (const key in classActions) {
            if (classActions[key].firstChild) {
              classActions[key].firstChild.style.opacity = '1';
              classActions[key].firstChild.style.pointerEvents = 'initial';
            }
          }
        }
      }, 50);
    },
    openDesign() {
      this.tableDesignModelVisible = true;
    },
    saveTableData(res) {
      this.item['containerTemplateId'] = res.id;
      this.item['containerTemplateInfo'] = JSON.stringify(res);
    }
  }
};